// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Main Wrapper */
.latters {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 20px;
  margin: 20px auto;
  padding: 20px;
  background: #f9f9f9;
  border-radius: 10px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
}

/* Buttons */
.letter_buttons {
  background: #d64400;
  color: #fff;
  font-size: 1rem;
  font-weight: bold;
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  text-transform: capitalize;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.1);
}

.letter_buttons:hover {
  background: #6a2201;
  transform: scale(1.05);
}

.letter_buttons:active {
  transform: scale(0.95);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

/* Responsive Design */
@media (max-width: 768px) {
  .letter_buttons {
    font-size: 0.9rem;
    padding: 8px 15px;
  }

  .latters {
    gap: 15px;
    padding: 15px;
  }
}

@media (max-width: 480px) {
  .letter_buttons {
    font-size: 0.85rem;
    padding: 8px 12px;
  }

  .latters {
    gap: 10px;
    padding: 10px;
  }
}





/* offer letter */

.offer_latter_form_wrapper {
  max-width: 600px;
  margin: 20px auto;
  padding: 20px;
  border: 1px solid #ccc;
  border-radius: 8px;
  background-color: #f9f9f9;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}
.offer_latter_downlode {
  height: 30px;
  width: 80px;
  background-color: cadetblue;
  color: white;
  border: none;
}
.offer_latter_close {
  height: 30px;
  width: 80px;
  background-color: red;
  color: white;
  border: none;
  margin-left: 5px;
}
.offer_latter_form {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.offer_latter_div {
  display: flex;
  flex-direction: column;
}

.offer_latter_lable {
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 5px;
  color: #333;
}

.offer_latter_input {
  padding: 10px;
  font-size: 14px;
  border: 1px solid #ccc;
  border-radius: 4px;
  width: 100%;
  box-sizing: border-box;
  transition: border-color 0.2s;
}

.offer_latter_input:focus {
  border-color: #007bff;
  outline: none;
}

.offer_latter_button {
  padding: 10px 15px;
  font-size: 16px;
  font-weight: bold;
  color: #fff;
  background-color: #007bff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.offer_latter_button:hover {
  background-color: #0056b3;
}

@media screen and (max-width: 768px) {
  .offer_latter_form_wrapper {
    padding: 15px;
  }

  .offer_latter_button {
    font-size: 14px;
    padding: 10px;
  }
}

@media screen and (max-width: 480px) {
  .offer_latter_lable {
    font-size: 12px;
  }

  .offer_latter_input {
    font-size: 12px;
    padding: 8px;
  }

  .offer_latter_button {
    font-size: 14px;
    padding: 8px 10px;
  }
}

/* offer table */
.offer_table_wrapper {
  max-width: 100%;
  margin: 20px auto;
  padding: 10px;
  overflow-x: auto;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  background-color: #f9f9f9;
}

.offer_table {
  width: 100%;
  border-collapse: collapse;
  text-align: left;
}

.offer_thead {
  background-color: #007bff;
  color: #fff;
}

.offer_thead th {
  padding: 12px 8px;
  font-size: 14px;
  font-weight: bold;
}

.offer_tbody td {
  padding: 10px 8px;
  border-bottom: 1px solid #ddd;
  font-size: 14px;
  color: #333;
}

.offer_tbody tr:nth-child(even) {
  background-color: #f2f2f2;
}

.offer_tbody tr:hover {
  background-color: #f0f8ff;
}

.latter_show_button,
.latter_show_delete {
  padding: 6px 10px;
  font-size: 12px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.latter_show_button {
  background-color: #28a745;
  color: #fff;
}

.latter_show_button:hover {
  background-color: #218838;
}

.latter_show_delete {
  background-color: #dc3545;
  color: #fff;
  margin-left: 5px;
}

.latter_show_delete:hover {
  background-color: #c82333;
}

@media screen and (max-width: 768px) {
  .offer_thead th,
  .offer_tbody td {
    font-size: 12px;
    padding: 8px 6px;
  }

  .latter_show_button,
  .latter_show_delete {
    font-size: 10px;
    padding: 5px 8px;
  }
}

@media screen and (max-width: 480px) {
  .offer_table_wrapper {
    padding: 5px;
  }

  .offer_thead th,
  .offer_tbody td {
    font-size: 10px;
    padding: 6px 4px;
  }

  .latter_show_button,
  .latter_show_delete {
    font-size: 8px;
    padding: 4px 6px;
  }
}

/* Add responsiveness for smaller screens */
@media screen and (max-width: 1024px) {
  .offer_latter_main_wrapper {
    padding: 15px;
  }

  .offer_latter_main_wrapper button {
    font-size: 14px;
    padding: 8px 15px;
  }

  .offer_latter_main_wrapper div[style*="flex-direction: row"] {
    flex-direction: column;
    align-items: flex-start;
  }

  .offer_latter_main_wrapper img {
    max-height: 80px;
  }

  .offer_latter_main_wrapper div[style*="line-height: 40px"],
  div[style*="line-height: 30px"] {
    line-height: 25px;
    font-size: 14px;
  }

  div[style*="justify-content: right"],
  div[style*="justify-content: space-between"] {
    justify-content: flex-start;
  }

  p {
    margin: 5px 0;
  }

  div[style*="padding: 30px"] {
    padding: 15px;
  }

  .offer_letter_heading {
    font-size: 18px;
  }
}

@media screen and (max-width: 768px) {
  .offer_latter_main_wrapper {
    padding: 10px;
  }

  .offer_latter_main_wrapper button {
    font-size: 12px;
    padding: 6px 10px;
  }

  .offer_latter_main_wrapper img {
    max-height: 60px;
  }

  div[style*="padding: 20px"] {
    padding: 10px;
  }

  div[style*="font-size: 14px"] {
    font-size: 12px;
  }

  .offer_letter_heading {
    font-size: 16px;
  }

  ol {
    margin-left: 15px;
  }
}

@media screen and (max-width: 480px) {
  .offer_latter_main_wrapper {
    padding: 5px;
  }

  .offer_latter_main_wrapper button {
    font-size: 10px;
    padding: 5px 8px;
  }

  .offer_latter_main_wrapper img {
    max-height: 50px;
  }

  div[style*="padding: 20px"],
  div[style*="padding: 10px"] {
    padding: 5px;
  }

  div[style*="line-height: 40px"] {
    line-height: 20px;
    font-size: 12px;
  }

  .offer_letter_heading {
    font-size: 14px;
  }

  ol {
    margin-left: 10px;
  }
}

/* relivling latter */
/* General Table Styling */
.reveling_table_wrapper {
  width: 100%;
  overflow-x: auto;
  margin: 20px 0;
}

.reveling_table {
  width: 100%;
  border-collapse: collapse;
  font-family: Arial, sans-serif;
  background-color: #f9f9f9;
}

.reveling_table th,
.reveling_table td {
  text-align: left;
  padding: 12px 15px;
  border: 1px solid #ddd;
}

.reveling_table thead th {
  background-color: #007bff;
  color: #fff;
  font-weight: bold;
  text-transform: uppercase;
  font-size: 14px;
}

.reveling_table tbody tr:nth-child(even) {
  background-color: #f2f2f2;
}

.reveling_table tbody tr:hover {
  background-color: #eaf1f7;
}

.latter_show_button,
.latter_show_delete {
  padding: 6px 12px;
  margin: 2px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
  text-transform: uppercase;
}
.doenlode_relieving {
  height: 30px;
  width: 110px;
  background-color: #4caf50;
  color: white;
  border: none;
}
.relieving_close_button {
  height: 30px;
  width: 110px;
  background-color: red;
  color: white;
  border: none;
  margin-left: 5px;
}
.latter_show_button {
  background-color: #4caf50;
  color: white;
}

.latter_show_delete {
  background-color: #f44336;
  color: white;
}

.latter_show_button:hover {
  background-color: #45a049;
}

.latter_show_delete:hover {
  background-color: #e53935;
}

/* Responsive Table Styling */
@media screen and (max-width: 1024px) {
  .reveling_table th,
  .reveling_table td {
    font-size: 12px;
    padding: 10px;
  }

  .latter_show_button,
  .latter_show_delete {
    font-size: 10px;
    padding: 4px 10px;
  }
}

@media screen and (max-width: 768px) {
  .reveling_table th,
  .reveling_table td {
    font-size: 11px;
    padding: 8px;
  }

  .latter_show_button,
  .latter_show_delete {
    font-size: 9px;
    padding: 3px 8px;
  }
}

@media screen and (max-width: 480px) {
  .reveling_table_wrapper {
    margin: 10px 0;
  }

  .reveling_table th,
  .reveling_table td {
    font-size: 10px;
    padding: 6px;
  }

  .latter_show_button,
  .latter_show_delete {
    font-size: 8px;
    padding: 2px 6px;
  }

  .reveling_table th:nth-child(3),
  .reveling_table td:nth-child(3),
  .reveling_table th:nth-child(8),
  .reveling_table td:nth-child(8) {
    display: none; /* Hide some columns for small screens */
  }
}

/* Base Styles */
.relieving_latter_main_container {
  padding: 20px;
  font-family: Arial, sans-serif;
}

.relieving_letter_container {
  margin: 20px auto;
 
  /* padding: 20px; */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

/* .relieving_letter_container img {
  height: 120px;
  width: auto;
  object-fit: contain;
} */

.dynamic {
  color: #555;
}

.signature p {
  margin: 5px 0;
}

/* Media Queries for Responsiveness */

/* Small devices (phones, <768px) */
@media (max-width: 768px) {
  .relieving_latter_main_container {
    padding: 10px;
  }

  .relieving_letter_container {
    /* padding: 10px; */
  }

  .relieving_letter_container > div {
    /* flex-direction: column; */
    align-items: flex-start;
  }

  /* .relieving_letter_container img {
    height: 80px;
    margin-bottom: 10px;
  } */

  .relieving_letter_container ul {
    margin-left: 20px;
  }

  .relieving_letter_container ul li {
    width: auto;
  }

  .relieving_letter_container h2,
  .relieving_letter_container p,
  .relieving_letter_container ul {
    text-align: left;
    margin-left: 10px;
    margin-right: 10px;
  }

  .relieving_latter_button {
    width: 100%;
    margin-bottom: 10px;
  }
}

/* Medium devices (tablets, 768px to 1024px) */
@media (min-width: 768px) and (max-width: 1024px) {
  .relieving_latter_main_container {
    padding: 15px;
  }

  .relieving_letter_container {
    padding: 15px;
  }

  /* .relieving_letter_container > div {
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
  } */

  .relieving_letter_container ul li {
    width: 100%;
    margin-bottom: 10px;
  }
}

/* Large devices (desktops, >1024px) */
@media (min-width: 1024px) {
  .relieving_latter_main_container {
    max-width: 1200px;
    margin: auto;
  }

  .relieving_letter_container {
    /* padding: 20px; */
  }

  .relieving_letter_container ul li {
    width: 400px;
  }
}
/* allotment letter */
.allotment_letter_form_wrapper {
  display: flex;
  justify-content: center;
  padding: 20px;
  background-color: #f4f4f4;
}

.alotment_latter_form {
  background-color: #fff;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 600px;
}

.alotment_latter_form_label {
  font-size: 14px;
  color: #333;
  display: block;
  margin-bottom: 8px;
}

.alotment_latter_form_input {
  width: 100%;
  padding: 10px;
  margin-bottom: 12px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 14px;
  background-color: #f9f9f9;
}

.alotment_latter_form_input:focus {
  border-color: #007bff;
  background-color: #fff;
  outline: none;
}

.alotment_latter_form_button {
  background-color: #007bff;
  color: white;
  border: none;
  padding: 12px;
  width: 100%;
  border-radius: 4px;
  font-size: 16px;
  cursor: pointer;
}

.alotment_latter_form_button:hover {
  background-color: #0056b3;
}

@media (max-width: 768px) {
  .allotment_latter_form {
    padding: 15px;
  }

  .alotment_latter_form_label {
    font-size: 13px;
  }

  .alotment_latter_form_input {
    font-size: 13px;
    padding: 8px;
  }

  .alotment_latter_form_button {
    padding: 10px;
    font-size: 14px;
  }
}

@media (max-width: 480px) {
  .allotment_latter_form {
    padding: 10px;
  }

  .alotment_latter_form_label {
    font-size: 12px;
  }

  .alotment_latter_form_input {
    font-size: 12px;
    padding: 6px;
  }

  .alotment_latter_form_button {
    padding: 8px;
    font-size: 12px;
  }
}
/*  */
.allotment_table_wrapper {
  max-width: 100%;
  overflow-x: auto;
}

.allotment_table {
  width: 100%;
  border-collapse: collapse;
  margin: 0 auto;
}

.allotment_table th,
.allotment_table td {
  padding: 12px;
  text-align: left;
  border: 1px solid #ddd;
}

.allotment_table th {
  background-color: #f4f4f4;
  font-weight: bold;
}

.allotment_table td {
  background-color: #fff;
}

.allotment_table tbody tr:nth-child(even) {
  background-color: #f9f9f9;
}

.allotment_table td button {
  margin-right: 10px;
  padding: 8px 16px;
  border: none;
  background-color: #4caf50;
  color: white;
  cursor: pointer;
}

.allotment_table td button.latter_show_delete {
  background-color: #f44336;
}

.allotment_table td button:hover {
  opacity: 0.8;
}

.allotment_table td button.latter_show_delete:hover {
  background-color: #d32f2f;
}

@media (max-width: 768px) {
  .allotment_table th,
  .allotment_table td {
    padding: 8px;
    font-size: 12px;
  }

  .allotment_table td button {
    padding: 6px 12px;
    font-size: 12px;
  }

  .allotment_table_wrapper {
    overflow-x: auto;
  }

  .allotment_table {
    font-size: 12px;
  }
}

@media (max-width: 480px) {
  .allotment_table th,
  .allotment_table td {
    padding: 6px;
    font-size: 10px;
  }

  .allotment_table td button {
    padding: 5px 10px;
    font-size: 10px;
  }

  .allotment_table {
    font-size: 10px;
  }
}

/* Responsive Design for Allotment Letter */
.allotment_latter_main_container {
  margin-left: 0; /* Adjust for smaller screens */
  padding: 10px;
}

.allotment_latter_container {
  padding: 10px;
}

/* Adjusting the logo size */
.allotment_latter_container img {
  height: 100px; /* Smaller logo for smaller screens */
  width: auto;
}

/* Responsiveness for text content */
.allotment_latter_container p,
.allotment_latter_container h2 {
  font-size: 16px; /* Smaller font size for mobile */
  line-height: 28px;
}

.allotment_latter_heading h2 {
  font-size: 20px;
}

.allotment_latter_heading p {
  font-size: 16px;
  line-height: 30px;
}

@media (max-width: 768px) {
  .allotment_latter_main_container {
    margin-left: 0; /* Remove margin for mobile */
    padding: 15px;
  }

  .allotment_latter_container {
    padding: 15px;
  }

  .allotment_latter_container img {
    height: 80px; /* Slightly smaller logo */
  }

  .allotment_latter_container p,
  .allotment_latter_container h2 {
    font-size: 14px;
    line-height: 24px;
  }

  .allotment_latter_heading h2 {
    font-size: 18px;
  }

  .allotment_latter_heading p {
    font-size: 14px;
  }

  .allotment_latter_container .allotment_latter_heading {
    margin-top: 10px;
  }

  .allotment_latter_main_container button {
    width: 100%; /* Make buttons full width for small screens */
    margin-top: 10px;
  }

  .allotment_latter_container div p {
    margin-right: 0;
  }
}

@media (max-width: 480px) {
  .allotment_latter_main_container {
    margin-left: 0;
    padding: 10px;
  }

  .allotment_latter_container {
    padding: 10px;
  }

  .allotment_latter_container img {
    height: 60px; /* Further reduce logo size for very small screens */
  }

  .allotment_latter_container p,
  .allotment_latter_container h2 {
    font-size: 12px; /* Further reduce font size */
    line-height: 20px;
  }

  .allotment_latter_heading h2 {
    font-size: 16px;
  }

  .allotment_latter_heading p {
    font-size: 12px;
  }

  .allotment_latter_container .allotment_latter_heading {
    margin-top: 5px;
  }

  .allotment_latter_main_container button {
    width: 100%; /* Full-width buttons for small screens */
  }
}
.allotment_latter_downlode_button {
  background-color: #4caf50;
  color: white;
  font-size: 16px;
  padding: 12px 24px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease, transform 0.2s ease;
  display: inline-block;
  margin-right: 10px;
}

.allotment_latter_close_button {
  background-color: #f44336;
  color: white;
  font-size: 16px;
  padding: 12px 24px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease, transform 0.2s ease;
  display: inline-block;
}

.allotment_latter_downlode_button:hover {
  background-color: #45a049;
  transform: scale(1.05);
}

.allotment_latter_close_button:hover {
  background-color: #e53935;
  transform: scale(1.05);
}

.allotment_latter_downlode_button:focus,
.allotment_latter_close_button:focus {
  outline: 2px solid #ffcc00;
}

.allotment_latter_downlode_button:disabled,
.allotment_latter_close_button:disabled {
  background-color: #d3d3d3;
  cursor: not-allowed;
}

/* demand letter */

/* Basic Styles */
.demand_letter_page_heading {
  text-align: center;
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 20px;
}

.demand_latter_form_wrapper {
  max-width: 600px;
  margin: 0 auto;
  padding: 20px;
  background-color: #f9f9f9;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.demad_latter_form {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.demand_latter_form_input {
  padding: 12px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 14px;
  width: 100%;
}

.demand_latter_form_submit_button {
  padding: 12px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.demand_latter_form_submit_button:hover {
  background-color: #0056b3;
}

/* Media Queries for Responsiveness */
@media (max-width: 768px) {
  .demand_latter_form_wrapper {
    padding: 15px;
  }

  .demand_latter_form_input {
    font-size: 16px;
  }

  .demand_latter_form_submit_button {
    font-size: 18px;
  }
}

@media (max-width: 480px) {
  .demand_letter_page_heading {
    font-size: 20px;
  }

  .demand_latter_form_input {
    padding: 10px;
  }

  .demand_latter_form_submit_button {
    padding: 10px;
    font-size: 16px;
  }
}

.demand_latter_table_wrapper {
  overflow-x: auto;
  margin: 20px;
}

.demand_latter_table {
  width: 100%;
  border-collapse: collapse;
  background-color: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.demand_latter_thead {
  background-color: #007bff;
  color: white;
}

.demand_latter_thead th {
  padding: 12px 15px;
  text-align: left;
}

.demand_latter_tbody td {
  padding: 10px 15px;
  text-align: left;
}

.demand_latter_tbody tr:nth-child(even) {
  background-color: #f2f2f2;
}

.demand_latter_tbody tr:hover {
  background-color: #f1f1f1;
}

.demand_latter_table button {
  padding: 8px 15px;
  margin: 0 5px;
  border: none;
  cursor: pointer;
  font-size: 14px;
  border-radius: 5px;
}

.latter_show_button {
  background-color: #4caf50;
  color: white;
}

.latter_show_button:hover {
  background-color: #45a049;
}

.latter_show_delete {
  background-color: #f44336;
  color: white;
}

.latter_show_delete:hover {
  background-color: #e53935;
}

/* Responsiveness */
@media only screen and (max-width: 768px) {
  .demand_latter_table th,
  .demand_latter_table td {
    font-size: 12px;
    padding: 8px;
  }

  .demand_latter_table {
    font-size: 12px;
  }

  .demand_latter_table button {
    font-size: 12px;
    padding: 6px 12px;
  }

  .demand_latter_table_wrapper {
    padding: 10px;
  }

  .demand_latter_thead th {
    padding: 8px 12px;
  }
}

@media only screen and (max-width: 480px) {
  .demand_latter_table {
    font-size: 10px;
  }

  .demand_latter_thead th,
  .demand_latter_tbody td {
    padding: 6px 10px;
  }

  .demand_latter_table button {
    font-size: 10px;
    padding: 5px 10px;
  }
}

.demand_latter_dowmlode_button,
.demand_latter_close_button {
  padding: 10px 20px;
  border-radius: 5px;
  font-size: 14px;
  font-weight: bold;
  border: none;
  cursor: pointer;
  transition: background-color 0.3s ease, transform 0.2s ease;
  display: inline-block;
  text-align: center;
  text-decoration: none;
}

.demand_latter_dowmlode_button {
  background-color: #4caf50;
  color: white;
}

.demand_latter_dowmlode_button:hover {
  background-color: #45a049;
  transform: translateY(-2px);
}

.demand_latter_dowmlode_button:active {
  background-color: #388e3c;
  transform: translateY(0);
}

.demand_latter_close_button {
  background-color: #f44336;
  color: white;
}

.demand_latter_close_button:hover {
  background-color: #e53935;
  transform: translateY(-2px);
}

.demand_latter_close_button:active {
  background-color: #d32f2f;
  transform: translateY(0);
}

@media only screen and (max-width: 768px) {
  .demand_latter_dowmlode_button,
  .demand_latter_close_button {
    font-size: 12px;
    padding: 8px 16px;
  }
}

@media only screen and (max-width: 480px) {
  .demand_latter_dowmlode_button,
  .demand_latter_close_button {
    font-size: 10px;
    padding: 6px 12px;
  }
}
/* letter heads */
.letter_heads_buttons {
  display: flex;
  gap: 15px;
  justify-content: center;
  margin: 20px;
}

.royalinfra_button,
.royal_loan_button {
  padding: 12px 25px;
  border-radius: 5px;
  font-size: 14px;
  font-weight: bold;
  border: none;
  cursor: pointer;
  transition: background-color 0.3s ease, transform 0.2s ease;
  display: inline-block;
  text-align: center;
}

.royalinfra_button {
  background-color: #2196f3;
  color: white;
}

.royalinfra_button:hover {
  background-color: #1976d2;
  transform: translateY(-2px);
}

.royalinfra_button:active {
  background-color: #1565c0;
  transform: translateY(0);
}

.royal_loan_button {
  background-color: #ff5722;
  color: white;
}

.royal_loan_button:hover {
  background-color: #e64a19;
  transform: translateY(-2px);
}

.royal_loan_button:active {
  background-color: #d32f2f;
  transform: translateY(0);
}

@media only screen and (max-width: 768px) {
  .royalinfra_button,
  .royal_loan_button {
    font-size: 12px;
    padding: 10px 20px;
  }
}

@media only screen and (max-width: 480px) {
  .royalinfra_button,
  .royal_loan_button {
    font-size: 10px;
    padding: 8px 18px;
  }
}

.royalinfra_downlode_button {
  padding: 12px 30px;
  border-radius: 5px;
  font-size: 14px;
  font-weight: bold;
  border: none;
  cursor: pointer;
  transition: background-color 0.3s ease, transform 0.2s ease;
  display: inline-block;
  text-align: center;
  background-color: #2196f3;
  color: white;
}

.royalinfra_downlode_button:hover {
  background-color: #1976d2;
  transform: translateY(-2px);
}

.royalinfra_downlode_button:active {
  background-color: #1565c0;
  transform: translateY(0);
}

@media only screen and (max-width: 768px) {
  .royalinfra_downlode_button {
    font-size: 12px;
    padding: 10px 24px;
  }
}

@media only screen and (max-width: 480px) {
  .royalinfra_downlode_button {
    font-size: 10px;
    padding: 8px 20px;
  }
}
.royalloan_downlode_button {
  padding: 12px 30px;
  border-radius: 5px;
  font-size: 14px;
  font-weight: bold;
  border: none;
  cursor: pointer;
  transition: background-color 0.3s ease, transform 0.2s ease;
  display: inline-block;
  text-align: center;
  background-color: #2196f3;
  color: white;
}

/*  possession letter css */
.possession_letter_form_wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 88vh;
  padding: 10px;
}
.possession_delete {
  height: 30px;
  width: 50px;
  background-color: red;
  color: white;
  border: none;
}
.possession_show {
  height: 30px;
  width: 50px;
  background-color: cadetblue;
  color: white;
  border: none;
}
.possion_close {
  height: 30px;
  width: 50px;
  background-color: red;
  color: white;
  border: none;
  margin-left: 10px;
}
.possession_letter {
  width: 100%;
  max-width: 450px;
  background: #ffffff;
  padding: 25px;
  border-radius: 10px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
  gap: 20px;
  text-align: center;
}

.possession_letter_input {
  width: 100%;
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 5px;
  font-size: 16px;
  background-color: #f9f9f9;
  transition: border-color 0.3s ease, box-shadow 0.3s ease;
}

.possession_letter_input:focus {
  border-color: #6a11cb;
  box-shadow: 0 0 5px rgba(106, 17, 203, 0.5);
  outline: none;
}

.possession_letter_submit_button {
  width: 100%;
  padding: 15px;
  font-size: 18px;
  font-weight: bold;
  color: #fff;
  background-color: #2575fc;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease, transform 0.2s ease;
}

.possession_letter_submit_button:hover {
  background-color: #6a11cb;
  transform: translateY(-2px);
}

.possession_letter_submit_button:active {
  transform: translateY(0);
}

@media (max-width: 768px) {
  .possession_letter {
    padding: 20px;
  }

  .possession_letter_input {
    font-size: 14px;
    padding: 10px;
  }

  .possession_letter_submit_button {
    font-size: 16px;
    padding: 12px;
  }
}

@media (min-width: 769px) and (max-width: 1200px) {
  .possession_letter {
    max-width: 550px;
  }
}

@media (min-width: 1201px) {
  .possession_letter {
    max-width: 600px;
  }
}

/* possion latter css */
.possession_letter_wrapper {
  padding: 10px;
}
.possession_table {
  width: 100%;
  border-collapse: collapse;
  margin: 20px 0;
  font-size: 16px;
  text-align: left;
}

.possession_table th,
.possession_table td {
  padding: 12px 15px;
  border: 1px solid #ddd;
}

.possession_table th {
  background-color: #0dada5;
  font-weight: bold;
  color: whitesmoke;
}
.possession_table tr:nth-child(even) {
  background-color: #f9f9f9;
}

.possession_table tr:hover {
  background-color: #f1f1f1;
}

@media (max-width: 768px) {
  .possession_table {
    font-size: 14px;
  }

  .possession_table th,
  .possession_table td {
    padding: 10px;
  }
}

@media (max-width: 480px) {
  .possession_table {
    font-size: 12px;
  }

  .possession_table th,
  .possession_table td {
    padding: 8px;
  }

  .possession_table {
    overflow-x: auto;
    display: block;
  }
}

@media (min-width: 1200px) {
  .possession_table {
    font-size: 18px;
  }

  .possession_table th,
  .possession_table td {
    padding: 15px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/latters/Latter.css"],"names":[],"mappings":"AAAA,iBAAiB;AACjB;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,SAAS;EACT,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA,YAAY;AACZ;EACE,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,0BAA0B;EAC1B,eAAe;EACf,gCAAgC;EAChC,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,wCAAwC;AAC1C;;AAEA,sBAAsB;AACtB;EACE;IACE,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,SAAS;IACT,aAAa;EACf;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,SAAS;IACT,aAAa;EACf;AACF;;;;;;AAMA,iBAAiB;;AAEjB;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;EACzB,wCAAwC;AAC1C;AACA;EACE,YAAY;EACZ,WAAW;EACX,2BAA2B;EAC3B,YAAY;EACZ,YAAY;AACd;AACA;EACE,YAAY;EACZ,WAAW;EACX,qBAAqB;EACrB,YAAY;EACZ,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,aAAa;EACf;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;AACF;;AAEA,gBAAgB;AAChB;EACE,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,gBAAgB;EAChB,wCAAwC;EACxC,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,eAAe;EACf,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;;IAEE,eAAe;IACf,gBAAgB;EAClB;;EAEA;;IAEE,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;;IAEE,eAAe;IACf,gBAAgB;EAClB;;EAEA;;IAEE,cAAc;IACd,gBAAgB;EAClB;AACF;;AAEA,2CAA2C;AAC3C;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;IAEE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;IAEE,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,qBAAqB;AACrB,0BAA0B;AAC1B;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;;EAEE,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,YAAY;AACd;AACA;EACE,YAAY;EACZ,YAAY;EACZ,qBAAqB;EACrB,YAAY;EACZ,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,6BAA6B;AAC7B;EACE;;IAEE,eAAe;IACf,aAAa;EACf;;EAEA;;IAEE,eAAe;IACf,iBAAiB;EACnB;AACF;;AAEA;EACE;;IAEE,eAAe;IACf,YAAY;EACd;;EAEA;;IAEE,cAAc;IACd,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;;IAEE,eAAe;IACf,YAAY;EACd;;EAEA;;IAEE,cAAc;IACd,gBAAgB;EAClB;;EAEA;;;;IAIE,aAAa,EAAE,wCAAwC;EACzD;AACF;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;;EAEjB,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;;;;GAIG;;AAEH;EACE,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA,qCAAqC;;AAErC,mCAAmC;AACnC;EACE;IACE,aAAa;EACf;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,4BAA4B;IAC5B,uBAAuB;EACzB;;EAEA;;;KAGG;;EAEH;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;EACb;;EAEA;;;IAGE,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,mBAAmB;EACrB;AACF;;AAEA,8CAA8C;AAC9C;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;;;;KAIG;;EAEH;IACE,WAAW;IACX,mBAAmB;EACrB;AACF;;AAEA,sCAAsC;AACtC;EACE;IACE,iBAAiB;IACjB,YAAY;EACd;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,YAAY;EACd;AACF;AACA,qBAAqB;AACrB;EACE,aAAa;EACb,uBAAuB;EACvB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,kBAAkB;EAClB,yCAAyC;EACzC,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,aAAa;IACb,eAAe;EACjB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;AACF;AACA,KAAK;AACL;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,cAAc;AAChB;;AAEA;;EAEE,aAAa;EACb,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;;IAEE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;;IAEE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,2CAA2C;AAC3C;EACE,cAAc,EAAE,+BAA+B;EAC/C,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA,4BAA4B;AAC5B;EACE,aAAa,EAAE,qCAAqC;EACpD,WAAW;AACb;;AAEA,oCAAoC;AACpC;;EAEE,eAAe,EAAE,iCAAiC;EAClD,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE;IACE,cAAc,EAAE,6BAA6B;IAC7C,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,YAAY,EAAE,0BAA0B;EAC1C;;EAEA;;IAEE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW,EAAE,8CAA8C;IAC3D,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,cAAc;IACd,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,YAAY,EAAE,oDAAoD;EACpE;;EAEA;;IAEE,eAAe,EAAE,6BAA6B;IAC9C,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW,EAAE,yCAAyC;EACxD;AACF;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,2DAA2D;EAC3D,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,2DAA2D;EAC3D,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;;EAEE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,kBAAkB;;AAElB,iBAAiB;AACjB;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,qCAAqC;AACrC;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,eAAe;EACjB;AACF;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,sBAAsB;EACtB,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,YAAY;EACZ,eAAe;EACf,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,mBAAmB;AACnB;EACE;;IAEE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;;IAEE,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;AACF;;AAEA;;EAEE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,2DAA2D;EAC3D,qBAAqB;EACrB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE;;IAEE,eAAe;IACf,iBAAiB;EACnB;AACF;;AAEA;EACE;;IAEE,eAAe;IACf,iBAAiB;EACnB;AACF;AACA,iBAAiB;AACjB;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,YAAY;AACd;;AAEA;;EAEE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,2DAA2D;EAC3D,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE;;IAEE,eAAe;IACf,kBAAkB;EACpB;AACF;;AAEA;EACE;;IAEE,eAAe;IACf,iBAAiB;EACnB;AACF;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,2DAA2D;EAC3D,qBAAqB;EACrB,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE;IACE,eAAe;IACf,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,eAAe;IACf,iBAAiB;EACnB;AACF;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,2DAA2D;EAC3D,qBAAqB;EACrB,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;AACd;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,YAAY;EACZ,WAAW;EACX,qBAAqB;EACrB,YAAY;EACZ,YAAY;AACd;AACA;EACE,YAAY;EACZ,WAAW;EACX,2BAA2B;EAC3B,YAAY;EACZ,YAAY;AACd;AACA;EACE,YAAY;EACZ,WAAW;EACX,qBAAqB;EACrB,YAAY;EACZ,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,yCAAyC;EACzC,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,wDAAwD;AAC1D;;AAEA;EACE,qBAAqB;EACrB,2CAA2C;EAC3C,aAAa;AACf;;AAEA;EACE,WAAW;EACX,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,2DAA2D;AAC7D;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,aAAa;EACf;;EAEA;IACE,eAAe;IACf,aAAa;EACf;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA,uBAAuB;AACvB;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;;IAEE,aAAa;EACf;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;;IAEE,YAAY;EACd;;EAEA;IACE,gBAAgB;IAChB,cAAc;EAChB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;;IAEE,aAAa;EACf;AACF","sourcesContent":["/* Main Wrapper */\n.latters {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 20px;\n  margin: 20px auto;\n  padding: 20px;\n  background: #f9f9f9;\n  border-radius: 10px;\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);\n}\n\n/* Buttons */\n.letter_buttons {\n  background: #d64400;\n  color: #fff;\n  font-size: 1rem;\n  font-weight: bold;\n  padding: 10px 20px;\n  border: none;\n  border-radius: 5px;\n  text-transform: capitalize;\n  cursor: pointer;\n  transition: all 0.3s ease-in-out;\n  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.1);\n}\n\n.letter_buttons:hover {\n  background: #6a2201;\n  transform: scale(1.05);\n}\n\n.letter_buttons:active {\n  transform: scale(0.95);\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .letter_buttons {\n    font-size: 0.9rem;\n    padding: 8px 15px;\n  }\n\n  .latters {\n    gap: 15px;\n    padding: 15px;\n  }\n}\n\n@media (max-width: 480px) {\n  .letter_buttons {\n    font-size: 0.85rem;\n    padding: 8px 12px;\n  }\n\n  .latters {\n    gap: 10px;\n    padding: 10px;\n  }\n}\n\n\n\n\n\n/* offer letter */\n\n.offer_latter_form_wrapper {\n  max-width: 600px;\n  margin: 20px auto;\n  padding: 20px;\n  border: 1px solid #ccc;\n  border-radius: 8px;\n  background-color: #f9f9f9;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n.offer_latter_downlode {\n  height: 30px;\n  width: 80px;\n  background-color: cadetblue;\n  color: white;\n  border: none;\n}\n.offer_latter_close {\n  height: 30px;\n  width: 80px;\n  background-color: red;\n  color: white;\n  border: none;\n  margin-left: 5px;\n}\n.offer_latter_form {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n}\n\n.offer_latter_div {\n  display: flex;\n  flex-direction: column;\n}\n\n.offer_latter_lable {\n  font-size: 14px;\n  font-weight: bold;\n  margin-bottom: 5px;\n  color: #333;\n}\n\n.offer_latter_input {\n  padding: 10px;\n  font-size: 14px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  width: 100%;\n  box-sizing: border-box;\n  transition: border-color 0.2s;\n}\n\n.offer_latter_input:focus {\n  border-color: #007bff;\n  outline: none;\n}\n\n.offer_latter_button {\n  padding: 10px 15px;\n  font-size: 16px;\n  font-weight: bold;\n  color: #fff;\n  background-color: #007bff;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.offer_latter_button:hover {\n  background-color: #0056b3;\n}\n\n@media screen and (max-width: 768px) {\n  .offer_latter_form_wrapper {\n    padding: 15px;\n  }\n\n  .offer_latter_button {\n    font-size: 14px;\n    padding: 10px;\n  }\n}\n\n@media screen and (max-width: 480px) {\n  .offer_latter_lable {\n    font-size: 12px;\n  }\n\n  .offer_latter_input {\n    font-size: 12px;\n    padding: 8px;\n  }\n\n  .offer_latter_button {\n    font-size: 14px;\n    padding: 8px 10px;\n  }\n}\n\n/* offer table */\n.offer_table_wrapper {\n  max-width: 100%;\n  margin: 20px auto;\n  padding: 10px;\n  overflow-x: auto;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  border-radius: 8px;\n  background-color: #f9f9f9;\n}\n\n.offer_table {\n  width: 100%;\n  border-collapse: collapse;\n  text-align: left;\n}\n\n.offer_thead {\n  background-color: #007bff;\n  color: #fff;\n}\n\n.offer_thead th {\n  padding: 12px 8px;\n  font-size: 14px;\n  font-weight: bold;\n}\n\n.offer_tbody td {\n  padding: 10px 8px;\n  border-bottom: 1px solid #ddd;\n  font-size: 14px;\n  color: #333;\n}\n\n.offer_tbody tr:nth-child(even) {\n  background-color: #f2f2f2;\n}\n\n.offer_tbody tr:hover {\n  background-color: #f0f8ff;\n}\n\n.latter_show_button,\n.latter_show_delete {\n  padding: 6px 10px;\n  font-size: 12px;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n}\n\n.latter_show_button {\n  background-color: #28a745;\n  color: #fff;\n}\n\n.latter_show_button:hover {\n  background-color: #218838;\n}\n\n.latter_show_delete {\n  background-color: #dc3545;\n  color: #fff;\n  margin-left: 5px;\n}\n\n.latter_show_delete:hover {\n  background-color: #c82333;\n}\n\n@media screen and (max-width: 768px) {\n  .offer_thead th,\n  .offer_tbody td {\n    font-size: 12px;\n    padding: 8px 6px;\n  }\n\n  .latter_show_button,\n  .latter_show_delete {\n    font-size: 10px;\n    padding: 5px 8px;\n  }\n}\n\n@media screen and (max-width: 480px) {\n  .offer_table_wrapper {\n    padding: 5px;\n  }\n\n  .offer_thead th,\n  .offer_tbody td {\n    font-size: 10px;\n    padding: 6px 4px;\n  }\n\n  .latter_show_button,\n  .latter_show_delete {\n    font-size: 8px;\n    padding: 4px 6px;\n  }\n}\n\n/* Add responsiveness for smaller screens */\n@media screen and (max-width: 1024px) {\n  .offer_latter_main_wrapper {\n    padding: 15px;\n  }\n\n  .offer_latter_main_wrapper button {\n    font-size: 14px;\n    padding: 8px 15px;\n  }\n\n  .offer_latter_main_wrapper div[style*=\"flex-direction: row\"] {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .offer_latter_main_wrapper img {\n    max-height: 80px;\n  }\n\n  .offer_latter_main_wrapper div[style*=\"line-height: 40px\"],\n  div[style*=\"line-height: 30px\"] {\n    line-height: 25px;\n    font-size: 14px;\n  }\n\n  div[style*=\"justify-content: right\"],\n  div[style*=\"justify-content: space-between\"] {\n    justify-content: flex-start;\n  }\n\n  p {\n    margin: 5px 0;\n  }\n\n  div[style*=\"padding: 30px\"] {\n    padding: 15px;\n  }\n\n  .offer_letter_heading {\n    font-size: 18px;\n  }\n}\n\n@media screen and (max-width: 768px) {\n  .offer_latter_main_wrapper {\n    padding: 10px;\n  }\n\n  .offer_latter_main_wrapper button {\n    font-size: 12px;\n    padding: 6px 10px;\n  }\n\n  .offer_latter_main_wrapper img {\n    max-height: 60px;\n  }\n\n  div[style*=\"padding: 20px\"] {\n    padding: 10px;\n  }\n\n  div[style*=\"font-size: 14px\"] {\n    font-size: 12px;\n  }\n\n  .offer_letter_heading {\n    font-size: 16px;\n  }\n\n  ol {\n    margin-left: 15px;\n  }\n}\n\n@media screen and (max-width: 480px) {\n  .offer_latter_main_wrapper {\n    padding: 5px;\n  }\n\n  .offer_latter_main_wrapper button {\n    font-size: 10px;\n    padding: 5px 8px;\n  }\n\n  .offer_latter_main_wrapper img {\n    max-height: 50px;\n  }\n\n  div[style*=\"padding: 20px\"],\n  div[style*=\"padding: 10px\"] {\n    padding: 5px;\n  }\n\n  div[style*=\"line-height: 40px\"] {\n    line-height: 20px;\n    font-size: 12px;\n  }\n\n  .offer_letter_heading {\n    font-size: 14px;\n  }\n\n  ol {\n    margin-left: 10px;\n  }\n}\n\n/* relivling latter */\n/* General Table Styling */\n.reveling_table_wrapper {\n  width: 100%;\n  overflow-x: auto;\n  margin: 20px 0;\n}\n\n.reveling_table {\n  width: 100%;\n  border-collapse: collapse;\n  font-family: Arial, sans-serif;\n  background-color: #f9f9f9;\n}\n\n.reveling_table th,\n.reveling_table td {\n  text-align: left;\n  padding: 12px 15px;\n  border: 1px solid #ddd;\n}\n\n.reveling_table thead th {\n  background-color: #007bff;\n  color: #fff;\n  font-weight: bold;\n  text-transform: uppercase;\n  font-size: 14px;\n}\n\n.reveling_table tbody tr:nth-child(even) {\n  background-color: #f2f2f2;\n}\n\n.reveling_table tbody tr:hover {\n  background-color: #eaf1f7;\n}\n\n.latter_show_button,\n.latter_show_delete {\n  padding: 6px 12px;\n  margin: 2px;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 12px;\n  text-transform: uppercase;\n}\n.doenlode_relieving {\n  height: 30px;\n  width: 110px;\n  background-color: #4caf50;\n  color: white;\n  border: none;\n}\n.relieving_close_button {\n  height: 30px;\n  width: 110px;\n  background-color: red;\n  color: white;\n  border: none;\n  margin-left: 5px;\n}\n.latter_show_button {\n  background-color: #4caf50;\n  color: white;\n}\n\n.latter_show_delete {\n  background-color: #f44336;\n  color: white;\n}\n\n.latter_show_button:hover {\n  background-color: #45a049;\n}\n\n.latter_show_delete:hover {\n  background-color: #e53935;\n}\n\n/* Responsive Table Styling */\n@media screen and (max-width: 1024px) {\n  .reveling_table th,\n  .reveling_table td {\n    font-size: 12px;\n    padding: 10px;\n  }\n\n  .latter_show_button,\n  .latter_show_delete {\n    font-size: 10px;\n    padding: 4px 10px;\n  }\n}\n\n@media screen and (max-width: 768px) {\n  .reveling_table th,\n  .reveling_table td {\n    font-size: 11px;\n    padding: 8px;\n  }\n\n  .latter_show_button,\n  .latter_show_delete {\n    font-size: 9px;\n    padding: 3px 8px;\n  }\n}\n\n@media screen and (max-width: 480px) {\n  .reveling_table_wrapper {\n    margin: 10px 0;\n  }\n\n  .reveling_table th,\n  .reveling_table td {\n    font-size: 10px;\n    padding: 6px;\n  }\n\n  .latter_show_button,\n  .latter_show_delete {\n    font-size: 8px;\n    padding: 2px 6px;\n  }\n\n  .reveling_table th:nth-child(3),\n  .reveling_table td:nth-child(3),\n  .reveling_table th:nth-child(8),\n  .reveling_table td:nth-child(8) {\n    display: none; /* Hide some columns for small screens */\n  }\n}\n\n/* Base Styles */\n.relieving_latter_main_container {\n  padding: 20px;\n  font-family: Arial, sans-serif;\n}\n\n.relieving_letter_container {\n  margin: 20px auto;\n \n  /* padding: 20px; */\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n/* .relieving_letter_container img {\n  height: 120px;\n  width: auto;\n  object-fit: contain;\n} */\n\n.dynamic {\n  color: #555;\n}\n\n.signature p {\n  margin: 5px 0;\n}\n\n/* Media Queries for Responsiveness */\n\n/* Small devices (phones, <768px) */\n@media (max-width: 768px) {\n  .relieving_latter_main_container {\n    padding: 10px;\n  }\n\n  .relieving_letter_container {\n    /* padding: 10px; */\n  }\n\n  .relieving_letter_container > div {\n    /* flex-direction: column; */\n    align-items: flex-start;\n  }\n\n  /* .relieving_letter_container img {\n    height: 80px;\n    margin-bottom: 10px;\n  } */\n\n  .relieving_letter_container ul {\n    margin-left: 20px;\n  }\n\n  .relieving_letter_container ul li {\n    width: auto;\n  }\n\n  .relieving_letter_container h2,\n  .relieving_letter_container p,\n  .relieving_letter_container ul {\n    text-align: left;\n    margin-left: 10px;\n    margin-right: 10px;\n  }\n\n  .relieving_latter_button {\n    width: 100%;\n    margin-bottom: 10px;\n  }\n}\n\n/* Medium devices (tablets, 768px to 1024px) */\n@media (min-width: 768px) and (max-width: 1024px) {\n  .relieving_latter_main_container {\n    padding: 15px;\n  }\n\n  .relieving_letter_container {\n    padding: 15px;\n  }\n\n  /* .relieving_letter_container > div {\n    flex-direction: row;\n    flex-wrap: wrap;\n    justify-content: space-between;\n  } */\n\n  .relieving_letter_container ul li {\n    width: 100%;\n    margin-bottom: 10px;\n  }\n}\n\n/* Large devices (desktops, >1024px) */\n@media (min-width: 1024px) {\n  .relieving_latter_main_container {\n    max-width: 1200px;\n    margin: auto;\n  }\n\n  .relieving_letter_container {\n    /* padding: 20px; */\n  }\n\n  .relieving_letter_container ul li {\n    width: 400px;\n  }\n}\n/* allotment letter */\n.allotment_letter_form_wrapper {\n  display: flex;\n  justify-content: center;\n  padding: 20px;\n  background-color: #f4f4f4;\n}\n\n.alotment_latter_form {\n  background-color: #fff;\n  padding: 20px;\n  border-radius: 8px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n  width: 100%;\n  max-width: 600px;\n}\n\n.alotment_latter_form_label {\n  font-size: 14px;\n  color: #333;\n  display: block;\n  margin-bottom: 8px;\n}\n\n.alotment_latter_form_input {\n  width: 100%;\n  padding: 10px;\n  margin-bottom: 12px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  font-size: 14px;\n  background-color: #f9f9f9;\n}\n\n.alotment_latter_form_input:focus {\n  border-color: #007bff;\n  background-color: #fff;\n  outline: none;\n}\n\n.alotment_latter_form_button {\n  background-color: #007bff;\n  color: white;\n  border: none;\n  padding: 12px;\n  width: 100%;\n  border-radius: 4px;\n  font-size: 16px;\n  cursor: pointer;\n}\n\n.alotment_latter_form_button:hover {\n  background-color: #0056b3;\n}\n\n@media (max-width: 768px) {\n  .allotment_latter_form {\n    padding: 15px;\n  }\n\n  .alotment_latter_form_label {\n    font-size: 13px;\n  }\n\n  .alotment_latter_form_input {\n    font-size: 13px;\n    padding: 8px;\n  }\n\n  .alotment_latter_form_button {\n    padding: 10px;\n    font-size: 14px;\n  }\n}\n\n@media (max-width: 480px) {\n  .allotment_latter_form {\n    padding: 10px;\n  }\n\n  .alotment_latter_form_label {\n    font-size: 12px;\n  }\n\n  .alotment_latter_form_input {\n    font-size: 12px;\n    padding: 6px;\n  }\n\n  .alotment_latter_form_button {\n    padding: 8px;\n    font-size: 12px;\n  }\n}\n/*  */\n.allotment_table_wrapper {\n  max-width: 100%;\n  overflow-x: auto;\n}\n\n.allotment_table {\n  width: 100%;\n  border-collapse: collapse;\n  margin: 0 auto;\n}\n\n.allotment_table th,\n.allotment_table td {\n  padding: 12px;\n  text-align: left;\n  border: 1px solid #ddd;\n}\n\n.allotment_table th {\n  background-color: #f4f4f4;\n  font-weight: bold;\n}\n\n.allotment_table td {\n  background-color: #fff;\n}\n\n.allotment_table tbody tr:nth-child(even) {\n  background-color: #f9f9f9;\n}\n\n.allotment_table td button {\n  margin-right: 10px;\n  padding: 8px 16px;\n  border: none;\n  background-color: #4caf50;\n  color: white;\n  cursor: pointer;\n}\n\n.allotment_table td button.latter_show_delete {\n  background-color: #f44336;\n}\n\n.allotment_table td button:hover {\n  opacity: 0.8;\n}\n\n.allotment_table td button.latter_show_delete:hover {\n  background-color: #d32f2f;\n}\n\n@media (max-width: 768px) {\n  .allotment_table th,\n  .allotment_table td {\n    padding: 8px;\n    font-size: 12px;\n  }\n\n  .allotment_table td button {\n    padding: 6px 12px;\n    font-size: 12px;\n  }\n\n  .allotment_table_wrapper {\n    overflow-x: auto;\n  }\n\n  .allotment_table {\n    font-size: 12px;\n  }\n}\n\n@media (max-width: 480px) {\n  .allotment_table th,\n  .allotment_table td {\n    padding: 6px;\n    font-size: 10px;\n  }\n\n  .allotment_table td button {\n    padding: 5px 10px;\n    font-size: 10px;\n  }\n\n  .allotment_table {\n    font-size: 10px;\n  }\n}\n\n/* Responsive Design for Allotment Letter */\n.allotment_latter_main_container {\n  margin-left: 0; /* Adjust for smaller screens */\n  padding: 10px;\n}\n\n.allotment_latter_container {\n  padding: 10px;\n}\n\n/* Adjusting the logo size */\n.allotment_latter_container img {\n  height: 100px; /* Smaller logo for smaller screens */\n  width: auto;\n}\n\n/* Responsiveness for text content */\n.allotment_latter_container p,\n.allotment_latter_container h2 {\n  font-size: 16px; /* Smaller font size for mobile */\n  line-height: 28px;\n}\n\n.allotment_latter_heading h2 {\n  font-size: 20px;\n}\n\n.allotment_latter_heading p {\n  font-size: 16px;\n  line-height: 30px;\n}\n\n@media (max-width: 768px) {\n  .allotment_latter_main_container {\n    margin-left: 0; /* Remove margin for mobile */\n    padding: 15px;\n  }\n\n  .allotment_latter_container {\n    padding: 15px;\n  }\n\n  .allotment_latter_container img {\n    height: 80px; /* Slightly smaller logo */\n  }\n\n  .allotment_latter_container p,\n  .allotment_latter_container h2 {\n    font-size: 14px;\n    line-height: 24px;\n  }\n\n  .allotment_latter_heading h2 {\n    font-size: 18px;\n  }\n\n  .allotment_latter_heading p {\n    font-size: 14px;\n  }\n\n  .allotment_latter_container .allotment_latter_heading {\n    margin-top: 10px;\n  }\n\n  .allotment_latter_main_container button {\n    width: 100%; /* Make buttons full width for small screens */\n    margin-top: 10px;\n  }\n\n  .allotment_latter_container div p {\n    margin-right: 0;\n  }\n}\n\n@media (max-width: 480px) {\n  .allotment_latter_main_container {\n    margin-left: 0;\n    padding: 10px;\n  }\n\n  .allotment_latter_container {\n    padding: 10px;\n  }\n\n  .allotment_latter_container img {\n    height: 60px; /* Further reduce logo size for very small screens */\n  }\n\n  .allotment_latter_container p,\n  .allotment_latter_container h2 {\n    font-size: 12px; /* Further reduce font size */\n    line-height: 20px;\n  }\n\n  .allotment_latter_heading h2 {\n    font-size: 16px;\n  }\n\n  .allotment_latter_heading p {\n    font-size: 12px;\n  }\n\n  .allotment_latter_container .allotment_latter_heading {\n    margin-top: 5px;\n  }\n\n  .allotment_latter_main_container button {\n    width: 100%; /* Full-width buttons for small screens */\n  }\n}\n.allotment_latter_downlode_button {\n  background-color: #4caf50;\n  color: white;\n  font-size: 16px;\n  padding: 12px 24px;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  transition: background-color 0.3s ease, transform 0.2s ease;\n  display: inline-block;\n  margin-right: 10px;\n}\n\n.allotment_latter_close_button {\n  background-color: #f44336;\n  color: white;\n  font-size: 16px;\n  padding: 12px 24px;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  transition: background-color 0.3s ease, transform 0.2s ease;\n  display: inline-block;\n}\n\n.allotment_latter_downlode_button:hover {\n  background-color: #45a049;\n  transform: scale(1.05);\n}\n\n.allotment_latter_close_button:hover {\n  background-color: #e53935;\n  transform: scale(1.05);\n}\n\n.allotment_latter_downlode_button:focus,\n.allotment_latter_close_button:focus {\n  outline: 2px solid #ffcc00;\n}\n\n.allotment_latter_downlode_button:disabled,\n.allotment_latter_close_button:disabled {\n  background-color: #d3d3d3;\n  cursor: not-allowed;\n}\n\n/* demand letter */\n\n/* Basic Styles */\n.demand_letter_page_heading {\n  text-align: center;\n  font-size: 24px;\n  font-weight: bold;\n  margin-bottom: 20px;\n}\n\n.demand_latter_form_wrapper {\n  max-width: 600px;\n  margin: 0 auto;\n  padding: 20px;\n  background-color: #f9f9f9;\n  border-radius: 8px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n}\n\n.demad_latter_form {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n}\n\n.demand_latter_form_input {\n  padding: 12px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  font-size: 14px;\n  width: 100%;\n}\n\n.demand_latter_form_submit_button {\n  padding: 12px;\n  background-color: #007bff;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  font-size: 16px;\n  cursor: pointer;\n  transition: background-color 0.3s;\n}\n\n.demand_latter_form_submit_button:hover {\n  background-color: #0056b3;\n}\n\n/* Media Queries for Responsiveness */\n@media (max-width: 768px) {\n  .demand_latter_form_wrapper {\n    padding: 15px;\n  }\n\n  .demand_latter_form_input {\n    font-size: 16px;\n  }\n\n  .demand_latter_form_submit_button {\n    font-size: 18px;\n  }\n}\n\n@media (max-width: 480px) {\n  .demand_letter_page_heading {\n    font-size: 20px;\n  }\n\n  .demand_latter_form_input {\n    padding: 10px;\n  }\n\n  .demand_latter_form_submit_button {\n    padding: 10px;\n    font-size: 16px;\n  }\n}\n\n.demand_latter_table_wrapper {\n  overflow-x: auto;\n  margin: 20px;\n}\n\n.demand_latter_table {\n  width: 100%;\n  border-collapse: collapse;\n  background-color: #fff;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.demand_latter_thead {\n  background-color: #007bff;\n  color: white;\n}\n\n.demand_latter_thead th {\n  padding: 12px 15px;\n  text-align: left;\n}\n\n.demand_latter_tbody td {\n  padding: 10px 15px;\n  text-align: left;\n}\n\n.demand_latter_tbody tr:nth-child(even) {\n  background-color: #f2f2f2;\n}\n\n.demand_latter_tbody tr:hover {\n  background-color: #f1f1f1;\n}\n\n.demand_latter_table button {\n  padding: 8px 15px;\n  margin: 0 5px;\n  border: none;\n  cursor: pointer;\n  font-size: 14px;\n  border-radius: 5px;\n}\n\n.latter_show_button {\n  background-color: #4caf50;\n  color: white;\n}\n\n.latter_show_button:hover {\n  background-color: #45a049;\n}\n\n.latter_show_delete {\n  background-color: #f44336;\n  color: white;\n}\n\n.latter_show_delete:hover {\n  background-color: #e53935;\n}\n\n/* Responsiveness */\n@media only screen and (max-width: 768px) {\n  .demand_latter_table th,\n  .demand_latter_table td {\n    font-size: 12px;\n    padding: 8px;\n  }\n\n  .demand_latter_table {\n    font-size: 12px;\n  }\n\n  .demand_latter_table button {\n    font-size: 12px;\n    padding: 6px 12px;\n  }\n\n  .demand_latter_table_wrapper {\n    padding: 10px;\n  }\n\n  .demand_latter_thead th {\n    padding: 8px 12px;\n  }\n}\n\n@media only screen and (max-width: 480px) {\n  .demand_latter_table {\n    font-size: 10px;\n  }\n\n  .demand_latter_thead th,\n  .demand_latter_tbody td {\n    padding: 6px 10px;\n  }\n\n  .demand_latter_table button {\n    font-size: 10px;\n    padding: 5px 10px;\n  }\n}\n\n.demand_latter_dowmlode_button,\n.demand_latter_close_button {\n  padding: 10px 20px;\n  border-radius: 5px;\n  font-size: 14px;\n  font-weight: bold;\n  border: none;\n  cursor: pointer;\n  transition: background-color 0.3s ease, transform 0.2s ease;\n  display: inline-block;\n  text-align: center;\n  text-decoration: none;\n}\n\n.demand_latter_dowmlode_button {\n  background-color: #4caf50;\n  color: white;\n}\n\n.demand_latter_dowmlode_button:hover {\n  background-color: #45a049;\n  transform: translateY(-2px);\n}\n\n.demand_latter_dowmlode_button:active {\n  background-color: #388e3c;\n  transform: translateY(0);\n}\n\n.demand_latter_close_button {\n  background-color: #f44336;\n  color: white;\n}\n\n.demand_latter_close_button:hover {\n  background-color: #e53935;\n  transform: translateY(-2px);\n}\n\n.demand_latter_close_button:active {\n  background-color: #d32f2f;\n  transform: translateY(0);\n}\n\n@media only screen and (max-width: 768px) {\n  .demand_latter_dowmlode_button,\n  .demand_latter_close_button {\n    font-size: 12px;\n    padding: 8px 16px;\n  }\n}\n\n@media only screen and (max-width: 480px) {\n  .demand_latter_dowmlode_button,\n  .demand_latter_close_button {\n    font-size: 10px;\n    padding: 6px 12px;\n  }\n}\n/* letter heads */\n.letter_heads_buttons {\n  display: flex;\n  gap: 15px;\n  justify-content: center;\n  margin: 20px;\n}\n\n.royalinfra_button,\n.royal_loan_button {\n  padding: 12px 25px;\n  border-radius: 5px;\n  font-size: 14px;\n  font-weight: bold;\n  border: none;\n  cursor: pointer;\n  transition: background-color 0.3s ease, transform 0.2s ease;\n  display: inline-block;\n  text-align: center;\n}\n\n.royalinfra_button {\n  background-color: #2196f3;\n  color: white;\n}\n\n.royalinfra_button:hover {\n  background-color: #1976d2;\n  transform: translateY(-2px);\n}\n\n.royalinfra_button:active {\n  background-color: #1565c0;\n  transform: translateY(0);\n}\n\n.royal_loan_button {\n  background-color: #ff5722;\n  color: white;\n}\n\n.royal_loan_button:hover {\n  background-color: #e64a19;\n  transform: translateY(-2px);\n}\n\n.royal_loan_button:active {\n  background-color: #d32f2f;\n  transform: translateY(0);\n}\n\n@media only screen and (max-width: 768px) {\n  .royalinfra_button,\n  .royal_loan_button {\n    font-size: 12px;\n    padding: 10px 20px;\n  }\n}\n\n@media only screen and (max-width: 480px) {\n  .royalinfra_button,\n  .royal_loan_button {\n    font-size: 10px;\n    padding: 8px 18px;\n  }\n}\n\n.royalinfra_downlode_button {\n  padding: 12px 30px;\n  border-radius: 5px;\n  font-size: 14px;\n  font-weight: bold;\n  border: none;\n  cursor: pointer;\n  transition: background-color 0.3s ease, transform 0.2s ease;\n  display: inline-block;\n  text-align: center;\n  background-color: #2196f3;\n  color: white;\n}\n\n.royalinfra_downlode_button:hover {\n  background-color: #1976d2;\n  transform: translateY(-2px);\n}\n\n.royalinfra_downlode_button:active {\n  background-color: #1565c0;\n  transform: translateY(0);\n}\n\n@media only screen and (max-width: 768px) {\n  .royalinfra_downlode_button {\n    font-size: 12px;\n    padding: 10px 24px;\n  }\n}\n\n@media only screen and (max-width: 480px) {\n  .royalinfra_downlode_button {\n    font-size: 10px;\n    padding: 8px 20px;\n  }\n}\n.royalloan_downlode_button {\n  padding: 12px 30px;\n  border-radius: 5px;\n  font-size: 14px;\n  font-weight: bold;\n  border: none;\n  cursor: pointer;\n  transition: background-color 0.3s ease, transform 0.2s ease;\n  display: inline-block;\n  text-align: center;\n  background-color: #2196f3;\n  color: white;\n}\n\n/*  possession letter css */\n.possession_letter_form_wrapper {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 88vh;\n  padding: 10px;\n}\n.possession_delete {\n  height: 30px;\n  width: 50px;\n  background-color: red;\n  color: white;\n  border: none;\n}\n.possession_show {\n  height: 30px;\n  width: 50px;\n  background-color: cadetblue;\n  color: white;\n  border: none;\n}\n.possion_close {\n  height: 30px;\n  width: 50px;\n  background-color: red;\n  color: white;\n  border: none;\n  margin-left: 10px;\n}\n.possession_letter {\n  width: 100%;\n  max-width: 450px;\n  background: #ffffff;\n  padding: 25px;\n  border-radius: 10px;\n  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  text-align: center;\n}\n\n.possession_letter_input {\n  width: 100%;\n  padding: 12px;\n  border: 1px solid #ddd;\n  border-radius: 5px;\n  font-size: 16px;\n  background-color: #f9f9f9;\n  transition: border-color 0.3s ease, box-shadow 0.3s ease;\n}\n\n.possession_letter_input:focus {\n  border-color: #6a11cb;\n  box-shadow: 0 0 5px rgba(106, 17, 203, 0.5);\n  outline: none;\n}\n\n.possession_letter_submit_button {\n  width: 100%;\n  padding: 15px;\n  font-size: 18px;\n  font-weight: bold;\n  color: #fff;\n  background-color: #2575fc;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  transition: background-color 0.3s ease, transform 0.2s ease;\n}\n\n.possession_letter_submit_button:hover {\n  background-color: #6a11cb;\n  transform: translateY(-2px);\n}\n\n.possession_letter_submit_button:active {\n  transform: translateY(0);\n}\n\n@media (max-width: 768px) {\n  .possession_letter {\n    padding: 20px;\n  }\n\n  .possession_letter_input {\n    font-size: 14px;\n    padding: 10px;\n  }\n\n  .possession_letter_submit_button {\n    font-size: 16px;\n    padding: 12px;\n  }\n}\n\n@media (min-width: 769px) and (max-width: 1200px) {\n  .possession_letter {\n    max-width: 550px;\n  }\n}\n\n@media (min-width: 1201px) {\n  .possession_letter {\n    max-width: 600px;\n  }\n}\n\n/* possion latter css */\n.possession_letter_wrapper {\n  padding: 10px;\n}\n.possession_table {\n  width: 100%;\n  border-collapse: collapse;\n  margin: 20px 0;\n  font-size: 16px;\n  text-align: left;\n}\n\n.possession_table th,\n.possession_table td {\n  padding: 12px 15px;\n  border: 1px solid #ddd;\n}\n\n.possession_table th {\n  background-color: #0dada5;\n  font-weight: bold;\n  color: whitesmoke;\n}\n.possession_table tr:nth-child(even) {\n  background-color: #f9f9f9;\n}\n\n.possession_table tr:hover {\n  background-color: #f1f1f1;\n}\n\n@media (max-width: 768px) {\n  .possession_table {\n    font-size: 14px;\n  }\n\n  .possession_table th,\n  .possession_table td {\n    padding: 10px;\n  }\n}\n\n@media (max-width: 480px) {\n  .possession_table {\n    font-size: 12px;\n  }\n\n  .possession_table th,\n  .possession_table td {\n    padding: 8px;\n  }\n\n  .possession_table {\n    overflow-x: auto;\n    display: block;\n  }\n}\n\n@media (min-width: 1200px) {\n  .possession_table {\n    font-size: 18px;\n  }\n\n  .possession_table th,\n  .possession_table td {\n    padding: 15px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
